import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.getAlert();
  }

  async getAlert(){
    try {
        const alert = await fetch(`${this.el.dataset.alertEndpoint}`)
        const response = await alert.json();
        this.alertList = response;
        this.renderAlert();
    } catch (e){
        this.alertList = []
        this.el.remove();
    }
  }

  renderAlert(){
    const alertElement = this.alertList.map(el => {
        const alertContent = `
            <${el.AlertLink ? `a href="${el.AlertLink.Url}" target="${el.AlertLink.Target}"` : 'div'} class="alert-banner">
                <div class="alert-banner__container">
                    <div class="alert-banner__icon-primary-wrapper">
                        ${el.Icon ? `
                            <img class="alert-banner__icon" src="${el.Icon.Src}" alt="${el.Icon.Alt}"/>` : ''}
                        <span class="alert-banner__primary">${el.PrimaryCopy}</span>
                    </div>
                    <span class="alert-banner__secondary">${el.SecondaryCopy}</span>
                </div>
            </${el.AlertLink ? 'a' : 'div'}>
        `;
      return alertContent
    }).join('')
    this.el.innerHTML = alertElement
  }
}

export default Module;
